import ApiService from './api.service'

const PermissionsService = {
	getPermissions: function (data) {
		return ApiService.get(`/perm/lists`);
	},
	editPermission: function (newPermission) {
		return ApiService.post(`/perm/edit/${newPermission.id}`, newPermission);
	},
	getGroupPermissions: function () {
		return ApiService.get(`/perm/group-list`);
	},
	getExpiredItemsCount() {
		return ApiService.get(`/item-balance/qty-of/expired-items`)
	}
};

export default PermissionsService
